module.exports = __webpack_public_path__ + "static/img/full.002d671.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/full.png
// module id = 5nxN
// module chunks = 24